const ALL_OFF = {
    'credentials.enabled': false,
    'routing.basic': false,
    'usage.basic': false,
    'multi_user.enabled': false,
    'wallet_sharing.enabled': false,
    'attribution.three_dim': false,
    'conversations.retention': false,
    'conversations.classification': false,
    'knowledge_graph.enabled': false,
    'wiki.auto_generate': false,
    'rag.savings_panel': false,
    'dlp.hard_block': false,
    'dlp.auto_dlp': false,
    'rbac.custom_roles': false,
    'directory.sync': false,
    'sso.full': false,
    'audit.archive': false,
    'slm_audit.enabled': false,
    'pii_realtime.enabled': false,
    'ai_output_audit.enabled': false,
    'offline_mode.enabled': false,
    'local_inference.enabled': false,
};
const PERSONAL = {
    ...ALL_OFF,
    'credentials.enabled': true,
    'routing.basic': true,
    'usage.basic': true,
};
const ENTERPRISE = {
    ...PERSONAL,
    'multi_user.enabled': true,
    'wallet_sharing.enabled': true,
    'attribution.three_dim': true,
    'directory.sync': true,
};
const PRO = {
    ...ENTERPRISE,
    'conversations.retention': true,
    'conversations.classification': true,
    'knowledge_graph.enabled': true,
    'wiki.auto_generate': true,
    'rag.savings_panel': true,
    'dlp.hard_block': true,
    'dlp.auto_dlp': true,
    'rbac.custom_roles': true,
    'sso.full': true,
    'audit.archive': true,
};
const MAX = {
    ...PRO,
    'slm_audit.enabled': true,
    'pii_realtime.enabled': true,
    'ai_output_audit.enabled': true,
};
const ULTRA = {
    ...MAX,
    'offline_mode.enabled': true,
    'local_inference.enabled': true,
};
export const DEFAULT_FLAGS_BY_TIER = {
    personal: PERSONAL,
    enterprise: ENTERPRISE,
    pro: PRO,
    max: MAX,
    ultra: ULTRA,
};
export function resolveFeatureFlagsForLicenseTier(licenseTier, overrides) {
    return { ...DEFAULT_FLAGS_BY_TIER[licenseTier], ...overrides };
}
export function resolveFeatureFlagsForTenant(tenant, overrides) {
    return resolveFeatureFlagsForLicenseTier(tenant.licenseTier, overrides);
}
//# sourceMappingURL=feature-flags.js.map